import eventEmitter, { events } from 'core/events/eventEmitter';

export const NAVIGATED_INSIDE_THE_APP = 'NAVIGATED_INSIDE_THE_APP';

export const navigatedToUrl = (prevUrl, currentUrl) => async dispatch => {
  await eventEmitter.emit(events.APP_NAVIGATED, currentUrl);
  dispatch({ type: NAVIGATED_INSIDE_THE_APP, payload: { prevUrl, currentUrl } });
};
